module.exports = __webpack_public_path__ + "img/Medals_32.5da0b7bb.png";